export default "__VITE_ASSET__e7163a5d__"